<template>
  <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top">
   
    <div class="container">
      <b-navbar-brand
        href="#"
        style="
          width: 80px;
          margin-left: 0.3rem;
          font-size: 16px;
          color: black;
          font-weight: 700;
        "
        >AI创作中心</b-navbar-brand
      >
      <!-- <b-navbar-nav style="margin-left:0.5rem;font-size: 16px;color: black;">
                <b-nav-item  @click="jump_">提示词助手</b-nav-item>
      </b-navbar-nav> -->


      <!-- <b-navbar-toggle
        target="nav-collapse"
        @click="changestyle"
      ></b-navbar-toggle> -->
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="#"> </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto nav">
          <!-- <b-nav-item
            href="#"
            style="margin-left: 0.8rem; margin-top: 0.1rem; font-size: 16px"
            @click="tohomepage"
            id="tohomepage"
            >首页</b-nav-item
          > -->
          <!-- <b-nav-item 
            href="#"
            style="margin-left: 0.8rem; margin-top: 0.1rem; font-size: 16px"
          >
            <span @click="login" id="login">登录</span>
            <span>/</span>
            <span @click="register" id="reg">注册</span></b-nav-item
          > -->
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      currentIndex: 0,
      change: true,
    };
  },
  methods: {
    // login(e) {
    //   // console.log(e)
    //   if (this.$router.currentRoute.name != "login") {
    //     this.$router.push("/login");
        
    //   } else{
    //     var login_=document.getElementById('login')
    //     login_.style.pointerEvents="none"
    //   }
    // },
    // register(e) {
    //   // console.log(e)

    //   // console.log(this.$router.currentRoute)
    //   if (this.$router.currentRoute.name != "register") {
    //     this.$router.push("/register");
    //   } else{
    //     var reg_=document.getElementById('reg')
    //     reg_.style.pointerEvents="none"
    //   }
    // },
    // tohomepage(e) {
    //   // console.log(e)
    //   // console.log(this.$router.currentRoute)

    //   if (this.$router.currentRoute.name != "home") {
    //     this.$router.push("/");
    //   }else if(this.$router.currentRoute.name == "home"){
    //     var tohomepage=document.getElementById('tohomepage')
    //     tohomepage.style.pointerEvents="none"
    //   }
    // },
    // jump_(){
    //  window.location.href=(window.location.hostname == 'nestudio.neone.com.cn')? 'https://nestudio.neone.com.cn/ops/index.html' : 'https://nestudio.test.neone.com.cn/dist/ops/index.html'
    // },
    // changestyle(e) {
    //   if (this.change) {
    //     console.log(e)
       
    //     e.target.style.background =
    //       "url(https://nestudio.test.neone.com.cn/src/assets/有岛/group1.png) no-repeat center center";
    //     e.target.parentElement.style.pointerEvents = "none";
    //     e.target.style.pointerEvents = "all";
    //     this.change = !this.change;
    //   } else{
        
    //     e.target.style.background =
    //       "url(https://nestudio.test.neone.com.cn/src/assets/有岛/group2.png) no-repeat center center";
    //     e.target.parentElement.style.pointerEvents = "none";
    //     e.target.style.pointerEvents = "all";
    //     this.change = !this.change;
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.navbar {
  background-color: transparent !important;
}
.container {
  .navbar-toggler {
    font-size: 16px;
    padding: 0.3rem 0.65rem;
    border-color: rgba(255, 255, 255, 0);
    pointer-events: none;
    /deep/ .navbar-toggler-icon {
      pointer-events: all;
      background: url(../assets/有岛/group2.png) no-repeat center center;
    }
  }
  .navbar-nav {
    .nav-link {
      color: rgb(169, 169, 169);
    }
    .nav-link:hover {
      color: #409eff;
    }
  }
}
.changeText {
  text-decoration: underline;
}
.nav {
  position: relative;
  left: 81%;
}
// @media screen and(max-width:415px) {
//   .nav {
//   position: relative;
//   left: 71%;
// }
// }
@media screen and (min-width:300px) and (max-width:768px){
   .nav {
  position: relative;
  left: 72%;
}
}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
</style>



